"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EBlogTags = void 0;
var EBlogTags;
(function (EBlogTags) {
    EBlogTags["MRCP_PART_1"] = "MRCP_Part_1";
    EBlogTags["MRCP_PART_2"] = "MRCP_Part_2";
    EBlogTags["PACES"] = "MRCP_PACES";
    EBlogTags["MEDICAL_FINALS"] = "Medical_school_finals";
    EBlogTags["UKMLA"] = "UKMLA";
    EBlogTags["QUESMED"] = "Quesmed";
    EBlogTags["CLINICAL"] = "Clinical_placement";
    EBlogTags["MEDICAL_LEARNING"] = "Medical_school_learning";
    EBlogTags["UKMLA_AKT"] = "UKMLA_AKT";
    EBlogTags["QUESMED_MRCP"] = "Quesmed_MRCP";
    EBlogTags["MLA_AKT"] = "MLA_AKT";
    EBlogTags["MLA_CSPA"] = "MLA_CPSA";
    EBlogTags["MRCP_VIDEO"] = "MRCP_Video";
    EBlogTags["PLAB1"] = "PLAB1";
    EBlogTags["PLAB2"] = "PLAB2";
})(EBlogTags = exports.EBlogTags || (exports.EBlogTags = {}));
